import { Modal, Form, Button, Row, Col, Alert } from "react-bootstrap";
import { useState, useEffect } from "react";
import { getHashResultAction } from "../../Redux/Actions/HashActions";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../utils/types";
import Spinner from "../../Components/UI/Spinner/Spinner";
import FeatherIcon from 'feather-icons-react';

const HashModal = ({ showHashModal, onClose }: { showHashModal: boolean; onClose: () => void }) => {
  const [showModal, setShowModal] = useState(showHashModal);
  const [inputValue, setInputValue] = useState(""); 
  const [result, setResult] = useState(""); 
  const [error, setError] = useState("");

  const HashState = useSelector((state: IReduxState) => state.Hash);
  const dispatch = useDispatch();

  useEffect(() => {
    setShowModal(showHashModal);
    if (!showHashModal) {
      setInputValue("");
      setResult("");
      setError("");
    }
  }, [showHashModal]);

  useEffect(() => {
    if (HashState?.hash.result) {
      setError('')
      setResult(HashState.hash.result);
    }
    if (HashState?.hash.error){
      setResult('')
      setError(HashState?.hash.error)
    }
  }, [HashState]);

  const handleClose = () => {
    HashState.hash = '';
    setResult("");
    setShowModal(false);
    onClose();
  };

  const handleSubmit = async () => {
    if (!inputValue) {
      setError("Please enter a valid input.");
    } else {
      await dispatch(getHashResultAction(inputValue));
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(result);
  };

  return ( <>
    
    <Modal show={showModal} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton/>
      {HashState.loading && (
        <div className="popUpUser">
          <Spinner className="m-2" color={"primary"}></Spinner>
        </div>
      )}
      <Modal.Body>
  <Form>
    <Form.Group className="mb-3">
      <Row className="justify-content-start">
        <Col xs={9}>
          <Form.Label>Insert Hashed / Unhashed User ID</Form.Label>
          <Form.Control
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </Col>
        <Col xs="auto" className="d-flex align-items-end">
          <Button variant="primary" onClick={handleSubmit} className="mb-0">
            Submit
          </Button>
        </Col>
      </Row>
      {error && (
        <Col xs={4}>
        <Alert variant="danger" className="mt-2">
          {error}
        </Alert>
        </Col>
      )}
    </Form.Group>

    <Form.Group className="mb-3">
      <Row className="justify-content-start">
        <Col xs={9}>
          <Form.Label>Result</Form.Label>
          <Form.Control type="text" value={result} readOnly />
        </Col>
        <Col xs="auto" className="d-flex align-items-end">
          <Button variant="info" onClick={handleCopy} className="mb-0 ml-0">
            Copy
          </Button>
        </Col>
      </Row>
    </Form.Group>
  </Form>
</Modal.Body>


    </Modal>
    </>
  );
};

export const HashButton = ({ onClick, className }:
  {onClick: () => void, className:string}) => {
  return (
    <Button
      className={className}
      variant='warning'
      onClick={onClick}
    >
      <FeatherIcon icon="hash" size={17} style={{ verticalAlign: 'sub' }} /> User ID
    </Button>
  );
};


export default HashModal;
